import React from 'react';

import { GenericToolbar } from '../../../../../components/GenericToolbar';
import { pushAppRoute } from '../../../../../data/domain/route-manager';
import { useHistory } from 'react-router-dom';
import { isRecordFound, useSelectedSiteData } from '../../../../../hooks/data-hooks';
import { ContentContainer } from '../../../../../components/ContentContainer';
import { TrendsCard } from '../../../../../components/Trends';
import { useAppRoute } from '../../../../../hooks/app-route-hooks';
import { List, Card, Typography, Link } from '@mui/material';
import { useGetSiteSubscriptionDetails } from '../../../../../data/DataProviders/GetSiteSubscriptionProvider';
import { hideTrends } from '../../../../../lib/hide-trends-helper';
import { isDataLoaded, isDataError } from '../../../../../types';
import { useGetOrganizationCheckDetails } from '../../../../../data/DataProviders/GetOrgCheckProvider';
import { ReusableTrendsCardHeader } from '../../../../../components/ReusableTrendsGraph';

import { useLanguageLocale } from '../../../../../hooks/language-locale-hooks';
import { TrendsCardHeaderNotLoaded } from '../../../../../components/ReusableTrendsGraph/ReusableTrendCardContentLoader';
import { CenteredContent } from '../../../../../components/CenteredContent';
import { EmptyState } from '@brightlayer-ui/react-components';
import { ShowChart } from '@mui/icons-material';
import { CONTACT_EMAIL } from '../../../../../constants';
export const OverviewSiteTrends: React.FC = () => {
    const history = useHistory();
    const { t } = useLanguageLocale();
    const currentAppRoute = useAppRoute('OverviewSiteTrends');
    const selectedSiteData = useSelectedSiteData();
    const meshSiteSubscriptionDetails = useGetSiteSubscriptionDetails();
    const [trendsEnabled, setTrendsEnabled] = React.useState<boolean>(false);
    const getOrgCheckDetails = useGetOrganizationCheckDetails();
    const [getOrgTypeData, setgetOrgTypeData] = React.useState<any | null>(null);
    const [showError, setShowError] = React.useState(false);

    React.useEffect(() => {
        if (isDataLoaded(getOrgCheckDetails)) {
            setgetOrgTypeData(getOrgCheckDetails.value);
        }
    }, [getOrgCheckDetails]);
    React.useEffect(() => {
        if (meshSiteSubscriptionDetails !== null) {
            if (isDataLoaded(meshSiteSubscriptionDetails)) {
                setTrendsEnabled(meshSiteSubscriptionDetails.value.cloudDataSync.isTrendsEnabled);

                const error = hideTrends(meshSiteSubscriptionDetails.value);
                setShowError(error);
            }
        }
    }, [meshSiteSubscriptionDetails]);

    return (
        <>
            <GenericToolbar
                showBackButton
                backButtonOnClick={(): void => {
                    pushAppRoute(history, {
                        type: 'OverviewSite',
                        locationId: currentAppRoute.locationId,
                        siteId: currentAppRoute.siteId,
                    });
                }}
                title={'Trends'}
                subtitle={isRecordFound(selectedSiteData) ? selectedSiteData.value.name : ''}
            />

            <ContentContainer testId="site-details-trends-page" justifyContent="center">
                {((meshSiteSubscriptionDetails !== null && isDataLoaded(meshSiteSubscriptionDetails)) ||
                    (meshSiteSubscriptionDetails !== null && isDataError(meshSiteSubscriptionDetails))) &&
                    ((getOrgTypeData && trendsEnabled && !showError) || getOrgTypeData === null ? (
                        <TrendsCard large />
                    ) : (
                        <ContentContainer
                            testId="device-details-trends-page"
                            justifyContent="center"
                            paddingTop="0px"
                            minHeight="70vh"
                        >
                            <Card style={{ margin: '15px', marginTop: 15, marginBottom: 25, flex: 1 }}>
                                <List
                                    disablePadding
                                    subheader={
                                        <ReusableTrendsCardHeader
                                            title={t('DASHBOARD.SITE_DETAILS.TRENDS_CARD.TRENDVIEWER')}
                                            // large={props.large}
                                        >
                                            <TrendsCardHeaderNotLoaded />
                                        </ReusableTrendsCardHeader>
                                    }
                                >
                                    <CenteredContent style={{ height: '30vh' }}>
                                        <EmptyState
                                            icon={<ShowChart id="fail-icon" style={{ fontSize: '24px' }} />}
                                            title={'No Trends'}
                                            actions={
                                                <>
                                                    <Typography
                                                        variant="subtitle2"
                                                        // color="primary"
                                                        style={{ textAlign: 'center' }}
                                                    >
                                                        {'You don’t have access to trends.'}
                                                    </Typography>
                                                    <Typography
                                                        variant="subtitle2"
                                                        // color="primary"
                                                        style={{ textAlign: 'center' }}
                                                    >
                                                        {'Contact Eaton support at'}{' '}
                                                        <Link underline="always" href={`mailto:${CONTACT_EMAIL}`}>
                                                            {CONTACT_EMAIL}
                                                        </Link>{' '}
                                                    </Typography>
                                                </>
                                            }
                                        />
                                    </CenteredContent>
                                </List>
                            </Card>
                        </ContentContainer>
                    ))}
            </ContentContainer>
        </>
    );
};
